import React, { useEffect, useState, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Review1 from '../assets/review1.png';
import Review2 from '../assets/review2.png';
import Review3 from '../assets/review3.png';
import Review4 from '../assets/review4.png';
import Review5 from '../assets/review5.png';
import Review6 from '../assets/review6.jpg';
import { Carousel } from 'react-bootstrap';

const testimonials = [
  {
    name: 'Shahid Ali',
    role: 'Client',
    image: Review1,
    text: `Outstanding Product – A Game Changer!

I have been using this product for a while now, and I must say it has exceeded my expectations in every way. The features are thoughtfully designed and incredibly efficient. From its seamless user interface to its robust functionality, every aspect of this product reflects excellence.

What truly sets it apart is its reliability and ease of use. It streamlines tasks effortlessly, saving both time and effort. The developers have clearly put immense thought into ensuring a smooth and hassle-free experience.

I highly recommend this product to anyone looking for a top-tier solution. Kudos to the team behind this brilliant creation!
`,
    rating: '⭐⭐⭐⭐⭐',
    link: 'https://g.co/kgs/fmMMUTN'
  },
  {
    name: 'ranjana kumra',
    role: 'Client',
    image: Review3,
    text: `Very good organisation.very cost effective and innovative solutions!.Team is very responsive.well done guys!`,
    rating: '⭐⭐⭐⭐⭐',
    link: 'https://g.co/kgs/BPgdh1F'
  },
  {
    name: 'Naushad Parwez',
    role: 'Client',
    image: Review4,
    text: `Great work from the team. We highly recommend Warals to anyone seeking reliable and good-looking website development. Thank you, Warals team for transforming our ideas into a stunning and functional website.`,
    rating: '⭐⭐⭐⭐⭐',
    link: 'https://g.co/kgs/uQcnTxN'
  },
  {
    name: 'Imtiyaz Ahmed',
    role: 'Client',
    image: Review6,
    text: `I got what I needed within time. Great delivery and service.`,
    rating: '⭐⭐⭐⭐⭐',
    link: 'https://g.page/r/CZJ_Qci1zRlfEB0/review'
  },
  {
    name: 'anam shahab',
    role: 'Client',
    image: Review5,
    text: `I’ve had an excellent experience with Warals. Their software solutions are intuitive, reliable, and have greatly streamlined our processes.`,
    rating: '⭐⭐⭐⭐⭐',
    link: 'https://g.co/kgs/qkvPUk3'
  },
  {
    name: 'adiba ahmad',
    role: 'Client',
    image: Review2,
    text: `A better place to learn and it plays a vital role in nurturing the next generation of developers. Their products are designed to meet the diverse needs of businesses.They provide excellent learning opportunities for beginners, offering structured training sessions, hands-on projects, and expert guidance`,
    rating: '⭐⭐⭐⭐⭐',
    link: 'https://g.co/kgs/eSNYzPo'
  },
];

const Reviews = () => {
  const [cardsPerSlide, setCardsPerSlide] = useState(getCardsPerSlide());
  const carouselRef = useRef(null);

  function getCardsPerSlide() {
    return window.innerWidth < 768 ? 1 : 3;
  }

  useEffect(() => {
    const handleResize = () => {
      setCardsPerSlide(getCardsPerSlide());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const chunks = Array.from({ length: Math.ceil(testimonials.length / cardsPerSlide) }, (_, i) =>
    testimonials.slice(i * cardsPerSlide, i * cardsPerSlide + cardsPerSlide)
  );

  const handlePrev = () => {
    carouselRef.current.prev();
  };

  const handleNext = () => {
    carouselRef.current.next();
  };

  return (
    <section className="py-4 bg-light position-relative">
      <div className="container text-center">
        <h2 className="fw-bold mb-2">Loved By Our Customers</h2>
        <div className="mx-auto mb-4" style={{ width: '60px', height: '3px', backgroundColor: '#4cc9f0' }} />
        <p className="text-muted mb-4">
          Our hard work is appreciated by our clients all across the globe. Here are a
          few testimonials sent by some of our clients:
        </p>

        <div className="position-relative px-lg-5">
          <Carousel
            ref={carouselRef}
            indicators={false}
            controls={false}
            touch={true}
            interval={4000}
          >
            {chunks.map((group, groupIndex) => (
              <Carousel.Item key={groupIndex}>
                <div className="row justify-content-center">
                  {group.map((testimonial, index) => (
                    <div className="col-md-4 mb-4" key={index}>
                      <div
                        className="position-relative h-100"
                        style={{
                          width: '90%',
                          margin: '0 auto',
                          backgroundColor: '#ffffff',
                          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
                          borderRadius: '15px',
                          padding: '20px',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                          cursor: 'pointer',
                          minHeight: '330px', // ⭐ Prevent layout shift
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.transform = 'translateY(-5px)';
                          e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = '0 4px 10px rgba(0, 0, 0, 0.05)';
                        }}
                      >
                        {/* <span
                          className="position-absolute top-0 end-0 m-3"
                          style={{ fontSize: '1rem', color: '#f5c518' }}
                        > */}
                        <span
                          className="position-absolute"
                          style={{
                            top: '10px',
                            right: '10px',
                            fontSize: '0.9rem',
                            color: '#f5c518',
                            background: 'white',
                            padding: '2px 6px',
                            borderRadius: '10px',
                            zIndex: 2,
                          }}
                        >
                          {testimonial.rating}
                        </span>
                        <img
                          src={testimonial.image}
                          className="rounded-circle mx-auto mb-3"
                          alt={testimonial.name}
                          style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                        />
                        <h5 className="fw-bold">{testimonial.name}</h5>
                        <p className="text-muted">{testimonial.role}</p>
                        <p className="fst-italic" style={{ fontSize: '1.05rem' }}>
                          “{testimonial.text.length > 100 ? (
                            <>
                              {testimonial.text.substring(0, 100)}...
                              <a
                                href={testimonial.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="ms-1 text-primary text-decoration-none"
                              >
                                Read More
                              </a>
                            </>
                          ) : testimonial.text}”
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>

          {/* Navigation Arrows */}
          <button
            onClick={handlePrev}
            className="position-absolute top-50 start-0 translate-middle-y d-none d-md-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              border: 'none',
              backgroundColor: 'white',
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
              zIndex: 1,
              left: '-20px'
            }}
            aria-label="Previous testimonials"
          >
            <i className="bi bi-chevron-left text-primary" style={{ fontSize: '1.25rem' }} />
          </button>

          <button
            onClick={handleNext}
            className="position-absolute top-50 end-0 translate-middle-y d-none d-md-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              border: 'none',
              backgroundColor: 'white',
              boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
              zIndex: 1,
              right: '-20px'
            }}
            aria-label="Next testimonials"
          >
            <i className="bi bi-chevron-right text-primary" style={{ fontSize: '1.25rem' }} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
